import React, { useEffect, useRef } from 'react';

import config from 'constants/config';

const TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

const CloudflareCaptcha = ({ onLoadCaptcha }) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onLoadCaptchaRef = useRef(onLoadCaptcha);

  onLoadCaptchaRef.current = onLoadCaptcha;

  useEffect(() => {
    const renderWidget = () => {
      if (!window.turnstile || !containerRef.current || widgetIdRef.current !== null) return;

      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: config.turnstileSiteKey,
        callback: (token) => {
          if (onLoadCaptchaRef.current) {
            onLoadCaptchaRef.current(token);
          }
        },
        'error-callback': (code) => {
          console.warn(`Turnstile error ${code}, retrying`);
          return true; // error handled, let Turnstile auto-retry
        },
      });
    };

    let script;
    if (window.turnstile) {
      renderWidget();
    } else {
      script = document.querySelector(`script[src="${TURNSTILE_SCRIPT_SRC}"]`);
      if (!script) {
        script = document.createElement('script');
        script.src = TURNSTILE_SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
      script.addEventListener('load', renderWidget);
    }

    return () => {
      if (script) {
        script.removeEventListener('load', renderWidget);
      }
      if (widgetIdRef.current !== null && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch (e) {
          // widget already gone
        }
        widgetIdRef.current = null;
      }
    };
  }, []);

  return <div ref={containerRef} className="cf-turnstile" />;
};

export default CloudflareCaptcha;
